import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  CircularProgress,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import InventoryIcon from "@mui/icons-material/Inventory";
import { useSnackbar } from "notistack";
import CustomInput from "../../CustomForm/CustomInput";
import CustomTextArea from "../../CustomForm/CustomTextArea";
import FileUpload from "../../CustomForm/FileUpload";
import CustomDate from "../../CustomForm/CustomDate";

const PersonalInventoryModal = ({ show, onHide }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      enqueueSnackbar("Personal Inventory added successfully", {
        variant: "success",
      });
      setIsLoading(false);
      onHide();
    }, 1000);
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          boxShadow: "0px 24px 48px -12px rgba(16, 24, 40, 0.25)",
        },
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2.5,
            pb: 1.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                bgcolor: "#EFF8FF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InventoryIcon sx={{ color: "#2469F0", fontSize: 24 }} />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={600} sx={{ color: "#1A1A2E" }}>
                Add Personal Inventory
              </Typography>
              <Typography variant="caption" sx={{ color: "#6B7280" }}>
                Add new inventory item
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              color: "#9CA3AF",
              "&:hover": { bgcolor: "#F3F4F6", color: "#4B5563" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ opacity: 0.4 }} />
      </DialogTitle>

      <DialogContent sx={{ p: 2.5, pt: 2, overflowY: "visible" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5 }}>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <CustomInput
                label="Item Name *"
                name="item_name"
                placeholder="Enter item name"
                fullWidth
              />
            </Box>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <CustomInput
                label="Quantity"
                name="quantity"
                placeholder="Enter quantity"
                type="number"
                fullWidth
              />
            </Box>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <CustomInput
                label="Item Value"
                name="item_value"
                placeholder="Enter item value"
                fullWidth
              />
            </Box>
          </Box>

          <Box>
            <CustomTextArea
              label="Item Description *"
              name="item_description"
              placeholder="Enter item description"
              fullWidth
              rows={3}
            />
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5 }}>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <CustomInput
                label="Location *"
                name="location"
                placeholder="Enter location"
                fullWidth
              />
            </Box>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <FileUpload
                label="File Upload"
                name="file_upload"
                fullWidth
              />
            </Box>
            <Box sx={{ flex: "1 1 calc(33.33% - 20px)", minWidth: 200 }}>
              <CustomDate
                label="Date Deposited *"
                name="date_deposited"
                fullWidth
              />
            </Box>
          </Box>

          <Box>
            <CustomTextArea
              label="Witness Signature"
              name="signature"
              placeholder="Enter witness signature"
              fullWidth
              rows={2}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, pt: 0, gap: 1.5 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          disabled={isLoading}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "10px",
            borderColor: "#D0D5DD",
            color: "#344054",
            "&:hover": {
              bgcolor: "#F9FAFB",
              borderColor: "#98A2B3",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : <SaveIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "10px",
            bgcolor: "#2469F0",
            px: 3,
            "&:hover": {
              bgcolor: "#1A5BD4",
              boxShadow: "0px 4px 12px rgba(36, 105, 240, 0.3)",
            },
          }}
        >
          {isLoading ? "Saving..." : "Save Inventory"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonalInventoryModal;